import { createContext, useContext, useEffect, useState } from "react";

export const LANGS = ["it", "en", "de", "fr"];
export const LANG_LABELS = { it: "IT", en: "EN", de: "DE", fr: "FR" };

const dict = {
  it: {
    "nav.home": "Home", "nav.sleep": "Dove dormire", "nav.eat": "Dove si mangia bene (davvero)",
    "nav.do": "Cose da fare", "nav.sport": "Sport", "nav.wine": "Cantine",
    "nav.products": "Le cose buone di qui", "nav.dishes": "Piatti tipici", "nav.recipes": "Ricette",
    "nav.events": "Cosa c'è da fare", "nav.map": "Mappa", "nav.info": "Info utili",
    "nav.favorites": "I tuoi like", "nav.survey": "Dicci la tua", "nav.about": "Chi siamo", "nav.more": "Altro",
    "hero.kicker": "Golfo di Follonica · Maremma Toscana",
    "hero.line1": "Follonica", "hero.line2": "ti piacerà.", "hero.line3": "Garantito.",
    "hero.sub": "Il mare, la pineta e l'entroterra raccontati da chi ci vive. Zero brochure, solo dritte vere.",
    "hero.cta1": "Scopri cosa c'è da fare", "hero.cta2": "Apri la mappa",
    "search.placeholder": "Cerca: una spiaggia, un piatto, un vino…",
    "home.now": "In programma", "home.nowSub": "Cosa succede nei prossimi giorni in giro per il golfo",
    "home.allEvents": "Tutti gli eventi",
    "home.explore": "Da dove cominci?", "home.exploreSub": "Le nostre bacheche preferite, una per voglia",
    "home.manifesto": "Il manifesto",
    "home.m1t": "Il mare prima di tutto",
    "home.m1d": "Acqua bassa e tiepida, spiagge che non finiscono mai e il Ponentino che arriva puntuale a rinfrescare il pomeriggio.",
    "home.m2t": "La pineta è il nostro condizionatore",
    "home.m2d": "Chilometri di pini marittimi per pedalare, correre o semplicemente stare all'ombra con un gelato.",
    "home.m3t": "L'entroterra è la sorpresa",
    "home.m3d": "Borghi medievali, cantine e colline che sanno di vino. A venti minuti dal mare, un altro mondo.",
    "home.surveyTitle": "Due minuti per noi, un soggiorno migliore per tutti",
    "home.surveySub": "Raccontaci com'è andata: le tue risposte modellano la prossima edizione.",
    "home.surveyCta": "Rispondi al sondaggino",
    "common.discover": "Scopri", "common.book": "Prenota", "common.call": "Chiama",
    "common.website": "Sito web", "common.tickets": "Biglietti", "common.menu": "Menu / prenota",
    "common.family": "Adatto a famiglie", "common.pets": "Animali benvenuti",
    "common.like": "Metti un like", "common.liked": "Nei tuoi like", "common.remove": "Togli il like",
    "common.back": "Torna indietro", "common.all": "Tutti", "common.results": "risultati",
    "common.empty": "Niente da queste parti… prova a cambiare filtri!",
    "common.gallery": "Galleria", "common.loading": "Carico…",
    "common.price": "Fascia di prezzo", "common.zone": "Zona",
    "dir.search": "Cerca…", "dir.category": "Categoria", "dir.filters": "Filtri",
    "detail.where": "Dove si trova", "detail.contacts": "Contatti", "detail.tags": "In breve",
    "detail.servedIn": "Dove lo mangi", "detail.whereTaste": "Dove lo trovi e lo assaggi",
    "detail.inMenu": "Nel menu qui", "detail.organizedBy": "Organizzato / collegato a",
    "detail.dates": "Quando", "detail.openMap": "Apri in Google Maps",
    "events.title": "Cosa c'è da fare", "events.sub": "Il calendario vero, aggiornato in tempo reale. Se vieni dalla rivista cartacea: sei nel posto giusto, questa pagina è sempre fresca.",
    "events.qr": "Arrivi dalla rivista? Benissimo: questo è il calendario sempre aggiornato, anche dopo la stampa.",
    "events.empty": "Nessun evento in programma per ora. Torna a trovarci, qui si aggiorna in continuazione.",
    "map.title": "Tutto il territorio in una mappa", "map.sub": "Filtra i punti e costruisci il tuo giro perfetto.",
    "fav.title": "I tuoi like", "fav.sub": "La tua lista personale per il soggiorno.",
    "fav.empty": "Ancora nessun like. Vagabonda per il sito e tocca il cuoricino sulle schede che ti ispirano!",
    "survey.title": "Il sondaggino", "survey.sub": "Anonimo, velocissimo, utilissimo. Due minuti e torni in spiaggia.",
    "survey.submit": "Spedisci", "survey.sending": "Invio…",
    "survey.thanks": "Grazie! Un like anche a te.", "survey.thanksSub": "Le tue risposte ci aiutano a rendere Follonica ancora più piacevole.",
    "survey.multi": "puoi scegliere più risposte",
    "about.title": "Chi c'è dietro Follonica Like",
    "about.p1": "Follonica Like nasce da un'idea semplice: il territorio va raccontato da chi lo vive, non da brochure tutte uguali. Siamo una squadra di local, operatori e appassionati che hanno deciso di mettere in un unico posto le cose belle — e buone — del golfo.",
    "about.p2": "Il sito è il compagno digitale della rivista cartacea stagionale: il QR che trovi in edicola ti porta sempre a contenuti aggiornati, perché il territorio si muove più veloce della stampa.",
    "about.p3": "Sei un'attività del territorio e vuoi esserci? Scrivici: le schede si aggiornano in autonomia e gratis.",
    "about.contact": "Scrivici", "about.social": "Seguici",
    "footer.tag": "Il territorio che si merita un like.",
    "footer.sections": "Le bacheche", "footer.project": "Il progetto", "footer.follow": "Seguici",
    "footer.made": "Fatto con il sole in faccia a Follonica",
    "badge.top": "Top pick", "badge.local": "Consigliato dai locali",
  },
  en: {
    "nav.home": "Home", "nav.sleep": "Where to sleep", "nav.eat": "Where to eat well (really)",
    "nav.do": "Things to do", "nav.sport": "Sports", "nav.wine": "Wineries",
    "nav.products": "The good stuff from here", "nav.dishes": "Local dishes", "nav.recipes": "Recipes",
    "nav.events": "What's on", "nav.map": "Map", "nav.info": "Useful info",
    "nav.favorites": "Your likes", "nav.survey": "Tell us", "nav.about": "About us", "nav.more": "More",
    "hero.kicker": "Gulf of Follonica · Tuscan Maremma",
    "hero.line1": "Follonica", "hero.line2": "you'll like it.", "hero.line3": "Guaranteed.",
    "hero.sub": "The sea, the pinewood and the Tuscan inland, told by the people who live here. No brochures, just real tips.",
    "hero.cta1": "See what's on", "hero.cta2": "Open the map",
    "search.placeholder": "Search: a beach, a dish, a wine…",
    "home.now": "Coming up", "home.nowSub": "What's happening around the gulf in the next few days",
    "home.allEvents": "All events",
    "home.explore": "Where to start?", "home.exploreSub": "Our favourite boards, one for every craving",
    "home.manifesto": "The manifesto",
    "home.m1t": "The sea first of all",
    "home.m1d": "Shallow, warm water, endless beaches and the Ponentino breeze that shows up on time every afternoon.",
    "home.m2t": "The pinewood is our air conditioning",
    "home.m2d": "Miles of maritime pines to cycle, run or simply sit in the shade with a gelato.",
    "home.m3t": "The inland is the surprise",
    "home.m3d": "Medieval villages, wineries and hills that smell of wine. Twenty minutes from the sea, another world.",
    "home.surveyTitle": "Two minutes for us, a better stay for everyone",
    "home.surveySub": "Tell us how it went: your answers shape the next edition.",
    "home.surveyCta": "Take the mini-survey",
    "common.discover": "Discover", "common.book": "Book", "common.call": "Call",
    "common.website": "Website", "common.tickets": "Tickets", "common.menu": "Menu / book",
    "common.family": "Family friendly", "common.pets": "Pets welcome",
    "common.like": "Give a like", "common.liked": "In your likes", "common.remove": "Remove like",
    "common.back": "Go back", "common.all": "All", "common.results": "results",
    "common.empty": "Nothing around here… try changing the filters!",
    "common.gallery": "Gallery", "common.loading": "Loading…",
    "common.price": "Price range", "common.zone": "Area",
    "dir.search": "Search…", "dir.category": "Category", "dir.filters": "Filters",
    "detail.where": "Where it is", "detail.contacts": "Contacts", "detail.tags": "In short",
    "detail.servedIn": "Where to eat it", "detail.whereTaste": "Where to find and taste it",
    "detail.inMenu": "On the menu here", "detail.organizedBy": "Organized / linked to",
    "detail.dates": "When", "detail.openMap": "Open in Google Maps",
    "events.title": "What's on", "events.sub": "The real calendar, updated in real time. Coming from the printed magazine? You're in the right place: this page is always fresh.",
    "events.qr": "Coming from the magazine? Great: this calendar stays updated even after printing.",
    "events.empty": "No events scheduled right now. Come back soon, this page updates all the time.",
    "map.title": "The whole territory on one map", "map.sub": "Filter the pins and build your perfect tour.",
    "fav.title": "Your likes", "fav.sub": "Your personal list for the stay.",
    "fav.empty": "No likes yet. Wander around the site and tap the heart on the cards that inspire you!",
    "survey.title": "The mini-survey", "survey.sub": "Anonymous, super fast, super useful. Two minutes and you're back on the beach.",
    "survey.submit": "Send", "survey.sending": "Sending…",
    "survey.thanks": "Thank you! A like for you too.", "survey.thanksSub": "Your answers help us make Follonica even more enjoyable.",
    "survey.multi": "you can pick more than one",
    "about.title": "Who's behind Follonica Like",
    "about.p1": "Follonica Like was born from a simple idea: a territory should be told by the people who live it, not by identical brochures. We are a crew of locals, operators and enthusiasts who decided to put all the beautiful — and tasty — things of the gulf in one place.",
    "about.p2": "The site is the digital companion of the seasonal printed magazine: the QR code you find at the newsstand always brings you to updated content, because the territory moves faster than print.",
    "about.p3": "Are you a local business and want to be featured? Write to us: listings are self-managed and free.",
    "about.contact": "Write to us", "about.social": "Follow us",
    "footer.tag": "The territory that deserves a like.",
    "footer.sections": "The boards", "footer.project": "The project", "footer.follow": "Follow us",
    "footer.made": "Made with the sun in our face in Follonica",
    "badge.top": "Top pick", "badge.local": "Locals' pick",
  },
  de: {
    "nav.home": "Home", "nav.sleep": "Wo man schläft", "nav.eat": "Wo man gut isst (wirklich)",
    "nav.do": "Was man macht", "nav.sport": "Sport", "nav.wine": "Weingüter",
    "nav.products": "Die guten Sachen von hier", "nav.dishes": "Typische Gerichte", "nav.recipes": "Rezepte",
    "nav.events": "Was läuft", "nav.map": "Karte", "nav.info": "Nützliche Infos",
    "nav.favorites": "Deine Likes", "nav.survey": "Sag uns deine Meinung", "nav.about": "Über uns", "nav.more": "Mehr",
    "hero.kicker": "Golf von Follonica · Toskanische Maremma",
    "hero.line1": "Follonica", "hero.line2": "wird dir gefallen.", "hero.line3": "Garantiert.",
    "hero.sub": "Das Meer, die Pinetta und das toskanische Hinterland, erzählt von denen, die hier leben. Keine Broschüren, nur echte Tipps.",
    "hero.cta1": "Entdecke, was läuft", "hero.cta2": "Karte öffnen",
    "search.placeholder": "Suche: ein Strand, ein Gericht, ein Wein…",
    "home.now": "Demnächst", "home.nowSub": "Was in den nächsten Tagen rund um den Golf los ist",
    "home.allEvents": "Alle Events",
    "home.explore": "Wo anfangen?", "home.exploreSub": "Unsere Lieblingsbretter, eins für jede Lust",
    "home.manifesto": "Das Manifest",
    "home.m1t": "Das Meer zuerst",
    "home.m1d": "Flaches, warmes Wasser, endlose Strände und die Ponentino-Brise, die jeden Nachmittag pünktlich kommt.",
    "home.m2t": "Die Pinetta ist unsere Klimaanlage",
    "home.m2d": "Kilometer Seekiefern zum Radfahren, Laufen oder einfach im Schatten ein Eis essen.",
    "home.m3t": "Das Hinterland ist die Überraschung",
    "home.m3d": "Mittelalterliche Dörfer, Weingüter und Hügel, die nach Wein duften. Zwanzig Minuten vom Meer, eine andere Welt.",
    "home.surveyTitle": "Zwei Minuten für uns, ein besserer Urlaub für alle",
    "home.surveySub": "Sag uns, wie es war: Deine Antworten gestalten die nächste Ausgabe.",
    "home.surveyCta": "Mini-Umfrage ausfüllen",
    "common.discover": "Entdecken", "common.book": "Buchen", "common.call": "Anrufen",
    "common.website": "Webseite", "common.tickets": "Tickets", "common.menu": "Menü / buchen",
    "common.family": "Familienfreundlich", "common.pets": "Tiere willkommen",
    "common.like": "Like geben", "common.liked": "In deinen Likes", "common.remove": "Like entfernen",
    "common.back": "Zurück", "common.all": "Alle", "common.results": "Ergebnisse",
    "common.empty": "Hier ist nichts… versuch andere Filter!",
    "common.gallery": "Galerie", "common.loading": "Laden…",
    "common.price": "Preisklasse", "common.zone": "Gebiet",
    "dir.search": "Suchen…", "dir.category": "Kategorie", "dir.filters": "Filter",
    "detail.where": "Wo es ist", "detail.contacts": "Kontakte", "detail.tags": "Kurz gesagt",
    "detail.servedIn": "Wo man es isst", "detail.whereTaste": "Wo man es findet und probiert",
    "detail.inMenu": "Hier auf der Karte", "detail.organizedBy": "Organisiert / verbunden mit",
    "detail.dates": "Wann", "detail.openMap": "In Google Maps öffnen",
    "events.title": "Was läuft", "events.sub": "Der echte Kalender, in Echtzeit aktualisiert. Du kommst vom Print-Magazin? Dann bist du richtig: Diese Seite ist immer frisch.",
    "events.qr": "Vom Magazin hier? Prima: Dieser Kalender bleibt auch nach dem Druck aktuell.",
    "events.empty": "Gerade keine Events geplant. Schau bald wieder vorbei, hier ändert sich ständig etwas.",
    "map.title": "Das ganze Gebiet auf einer Karte", "map.sub": "Filtere die Pins und bau deine perfekte Tour.",
    "fav.title": "Deine Likes", "fav.sub": "Deine persönliche Liste für den Aufenthalt.",
    "fav.empty": "Noch keine Likes. Stöbere durch die Seite und tippe auf das Herz bei den Karten, die dich ansprechen!",
    "survey.title": "Die Mini-Umfrage", "survey.sub": "Anonym, superschnell, supernützlich. Zwei Minuten und du bist wieder am Strand.",
    "survey.submit": "Abschicken", "survey.sending": "Senden…",
    "survey.thanks": "Danke! Ein Like auch für dich.", "survey.thanksSub": "Deine Antworten helfen uns, Follonica noch schöner zu machen.",
    "survey.multi": "Mehrfachauswahl möglich",
    "about.title": "Wer hinter Follonica Like steckt",
    "about.p1": "Follonica Like entstand aus einer einfachen Idee: Eine Region sollte von denen erzählt werden, die sie leben — nicht von gleich aussehenden Broschüren. Wir sind ein Team aus Locals, Betreibern und Enthusiasten, die alle schönen — und leckeren — Dinge des Golfs an einem Ort sammeln wollten.",
    "about.p2": "Die Website ist der digitale Begleiter des saisonalen Print-Magazins: Der QR-Code am Kiosk führt dich immer zu aktuellen Inhalten, denn die Region bewegt sich schneller als der Druck.",
    "about.p3": "Du hast einen Betrieb in der Gegend und möchtest dabei sein? Schreib uns: Einträge werden selbst verwaltet und sind kostenlos.",
    "about.contact": "Schreib uns", "about.social": "Folge uns",
    "footer.tag": "Die Region, die ein Like verdient.",
    "footer.sections": "Die Bretter", "footer.project": "Das Projekt", "footer.follow": "Folge uns",
    "footer.made": "Gemacht mit Sonne im Gesicht in Follonica",
    "badge.top": "Top-Tipp", "badge.local": "Von Locals empfohlen",
  },
  fr: {
    "nav.home": "Accueil", "nav.sleep": "Où dormir", "nav.eat": "Où bien manger (vraiment)",
    "nav.do": "Que faire", "nav.sport": "Sports", "nav.wine": "Caves",
    "nav.products": "Les bonnes choses d'ici", "nav.dishes": "Plats typiques", "nav.recipes": "Recettes",
    "nav.events": "Qu'est-ce qu'on fait", "nav.map": "Carte", "nav.info": "Infos utiles",
    "nav.favorites": "Tes likes", "nav.survey": "Dis-nous tout", "nav.about": "Qui sommes-nous", "nav.more": "Plus",
    "hero.kicker": "Golfe de Follonica · Maremme toscane",
    "hero.line1": "Follonica", "hero.line2": "tu vas aimer.", "hero.line3": "Garanti.",
    "hero.sub": "La mer, la pinède et l'arrière-pays racontés par ceux qui y vivent. Zéro brochure, que des vrais tuyaux.",
    "hero.cta1": "Voir ce qu'il se passe", "hero.cta2": "Ouvrir la carte",
    "search.placeholder": "Cherche : une plage, un plat, un vin…",
    "home.now": "Au programme", "home.nowSub": "Ce qui se passe dans les prochains jours autour du golfe",
    "home.allEvents": "Tous les événements",
    "home.explore": "Par où commencer ?", "home.exploreSub": "Nos tableaux préférés, un pour chaque envie",
    "home.manifesto": "Le manifeste",
    "home.m1t": "La mer d'abord",
    "home.m1d": "Eau peu profonde et tiède, plages à n'en plus finir et le Ponentino qui arrive à l'heure chaque après-midi.",
    "home.m2t": "La pinède, c'est notre clim",
    "home.m2d": "Des kilomètres de pins maritimes pour pédaler, courir ou juste rester à l'ombre avec une glace.",
    "home.m3t": "L'arrière-pays, c'est la surprise",
    "home.m3d": "Villages médiévaux, caves et collines qui sentent le vin. À vingt minutes de la mer, un autre monde.",
    "home.surveyTitle": "Deux minutes pour toi, un meilleur séjour pour tous",
    "home.surveySub": "Raconte-nous comment ça s'est passé : tes réponses façonnent la prochaine édition.",
    "home.surveyCta": "Réponds au mini-sondage",
    "common.discover": "Découvrir", "common.book": "Réserver", "common.call": "Appeler",
    "common.website": "Site web", "common.tickets": "Billets", "common.menu": "Menu / réserver",
    "common.family": "Adapté aux familles", "common.pets": "Animaux bienvenus",
    "common.like": "Mets un like", "common.liked": "Dans tes likes", "common.remove": "Retirer le like",
    "common.back": "Retour", "common.all": "Tous", "common.results": "résultats",
    "common.empty": "Rien par ici… essaie de changer les filtres !",
    "common.gallery": "Galerie", "common.loading": "Chargement…",
    "common.price": "Gamme de prix", "common.zone": "Zone",
    "dir.search": "Cherche…", "dir.category": "Catégorie", "dir.filters": "Filtres",
    "detail.where": "Où c'est", "detail.contacts": "Contacts", "detail.tags": "En bref",
    "detail.servedIn": "Où le manger", "detail.whereTaste": "Où le trouver et le goûter",
    "detail.inMenu": "À la carte ici", "detail.organizedBy": "Organisé / lié à",
    "detail.dates": "Quand", "detail.openMap": "Ouvrir dans Google Maps",
    "events.title": "Qu'est-ce qu'on fait", "events.sub": "Le vrai calendrier, mis à jour en temps réel. Tu viens du magazine papier ? Tu es au bon endroit : cette page est toujours fraîche.",
    "events.qr": "Tu viens du magazine ? Parfait : ce calendrier reste à jour même après l'impression.",
    "events.empty": "Pas d'événement prévu pour l'instant. Reviens vite, ici ça bouge tout le temps.",
    "map.title": "Tout le territoire sur une carte", "map.sub": "Filtre les points et construis ton tour parfait.",
    "fav.title": "Tes likes", "fav.sub": "Ta liste perso pour le séjour.",
    "fav.empty": "Pas encore de like. Balade-toi sur le site et touche le petit cœur sur les fiches qui t'inspirent !",
    "survey.title": "Le mini-sondage", "survey.sub": "Anonyme, ultra rapide, super utile. Deux minutes et tu retournes à la plage.",
    "survey.submit": "Envoyer", "survey.sending": "Envoi…",
    "survey.thanks": "Merci ! Un like pour toi aussi.", "survey.thanksSub": "Tes réponses nous aident à rendre Follonica encore plus agréable.",
    "survey.multi": "tu peux choisir plusieurs réponses",
    "about.title": "Qui est derrière Follonica Like",
    "about.p1": "Follonica Like est né d'une idée simple : un territoire doit être raconté par ceux qui le vivent, pas par des brochures toutes pareilles. Nous sommes une bande de locaux, d'opérateurs et de passionnés qui ont décidé de réunir au même endroit les choses belles — et bonnes — du golfe.",
    "about.p2": "Le site est le compagnon numérique du magazine papier saisonnier : le QR code que tu trouves chez le marchand de journaux te mène toujours vers des contenus à jour, parce que le territoire bouge plus vite que l'impression.",
    "about.p3": "Tu as une activité dans le coin et tu veux en être ? Écris-nous : les fiches se gèrent en autonomie et gratuitement.",
    "about.contact": "Écris-nous", "about.social": "Suis-nous",
    "footer.tag": "Le territoire qui mérite un like.",
    "footer.sections": "Les tableaux", "footer.project": "Le projet", "footer.follow": "Suis-nous",
    "footer.made": "Fait avec le soleil en pleine face à Follonica",
    "badge.top": "Top pick", "badge.local": "Conseillé par les locaux",
  },
};

Object.assign(dict.it, {
  "events.propose": "Sei un'attività? Proponi il tuo evento",
  "propose.title": "Proponi il tuo evento",
  "propose.sub": "Raccontacelo in due minuti: noi lo controlliamo e, se tutto torna, lo pubblichiamo sul calendario.",
  "propose.name": "Il tuo nome / attività", "propose.email": "La tua email (serve per ricontattarti)",
  "propose.eventTitle": "Titolo dell'evento", "propose.desc": "Descrizione breve e invitante",
  "propose.start": "Inizio", "propose.end": "Fine", "propose.place": "Luogo",
  "propose.category": "Categoria", "propose.link": "Link biglietti o sito (facoltativo)",
  "propose.image": "URL immagine (facoltativo)", "propose.submit": "Invia la proposta",
  "propose.thanks": "Ricevuto! Ci pensiamo noi.",
  "propose.thanksSub": "Se l'evento torna, lo trovi pubblicato sul calendario entro pochi giorni.",
  "weather.title": "Meteo ora a Follonica", "weather.sea": "Acqua di mare", "weather.wind": "Vento",
  "weather.live": "dati live · Open-Meteo", "weather.clear": "Sereno", "weather.partly": "Parz. nuvoloso",
  "weather.cloudy": "Nuvoloso", "weather.fog": "Nebbia", "weather.rain": "Pioggia", "weather.storm": "Temporale",
});
Object.assign(dict.en, {
  "events.propose": "Are you a business? Propose your event",
  "propose.title": "Propose your event",
  "propose.sub": "Tell us in two minutes: we review it and, if everything checks out, we publish it on the calendar.",
  "propose.name": "Your name / business", "propose.email": "Your email (so we can reach you)",
  "propose.eventTitle": "Event title", "propose.desc": "Short, inviting description",
  "propose.start": "Start", "propose.end": "End", "propose.place": "Place",
  "propose.category": "Category", "propose.link": "Tickets or website link (optional)",
  "propose.image": "Image URL (optional)", "propose.submit": "Send proposal",
  "propose.thanks": "Got it! We'll take it from here.",
  "propose.thanksSub": "If the event checks out, you'll see it on the calendar within a few days.",
  "weather.title": "Weather now in Follonica", "weather.sea": "Sea water", "weather.wind": "Wind",
  "weather.live": "live data · Open-Meteo", "weather.clear": "Clear", "weather.partly": "Partly cloudy",
  "weather.cloudy": "Cloudy", "weather.fog": "Fog", "weather.rain": "Rain", "weather.storm": "Thunderstorm",
});
Object.assign(dict.de, {
  "events.propose": "Du hast einen Betrieb? Schlage dein Event vor",
  "propose.title": "Schlage dein Event vor",
  "propose.sub": "Erzähl es uns in zwei Minuten: Wir prüfen es und veröffentlichen es im Kalender, wenn alles passt.",
  "propose.name": "Dein Name / Betrieb", "propose.email": "Deine E-Mail (damit wir dich erreichen)",
  "propose.eventTitle": "Event-Titel", "propose.desc": "Kurze, einladende Beschreibung",
  "propose.start": "Beginn", "propose.end": "Ende", "propose.place": "Ort",
  "propose.category": "Kategorie", "propose.link": "Ticket- oder Website-Link (optional)",
  "propose.image": "Bild-URL (optional)", "propose.submit": "Vorschlag senden",
  "propose.thanks": "Angekommen! Wir kümmern uns.",
  "propose.thanksSub": "Wenn alles passt, findest du das Event in wenigen Tagen im Kalender.",
  "weather.title": "Wetter jetzt in Follonica", "weather.sea": "Meerwasser", "weather.wind": "Wind",
  "weather.live": "Live-Daten · Open-Meteo", "weather.clear": "Klar", "weather.partly": "Teilweise bewölkt",
  "weather.cloudy": "Bewölkt", "weather.fog": "Nebel", "weather.rain": "Regen", "weather.storm": "Gewitter",
});
Object.assign(dict.fr, {
  "events.propose": "Tu as une activité ? Propose ton événement",
  "propose.title": "Propose ton événement",
  "propose.sub": "Raconte-le-nous en deux minutes : on vérifie et, si tout est bon, on le publie au calendrier.",
  "propose.name": "Ton nom / activité", "propose.email": "Ton email (pour te recontacter)",
  "propose.eventTitle": "Titre de l'événement", "propose.desc": "Description courte et invitante",
  "propose.start": "Début", "propose.end": "Fin", "propose.place": "Lieu",
  "propose.category": "Catégorie", "propose.link": "Lien billets ou site (facultatif)",
  "propose.image": "URL de l'image (facultatif)", "propose.submit": "Envoyer la proposition",
  "propose.thanks": "Bien reçu ! On s'en occupe.",
  "propose.thanksSub": "Si tout est bon, tu le verras au calendrier dans quelques jours.",
  "weather.title": "Météo à Follonica", "weather.sea": "Eau de mer", "weather.wind": "Vent",
  "weather.live": "données live · Open-Meteo", "weather.clear": "Dégagé", "weather.partly": "Partiellement nuageux",
  "weather.cloudy": "Nuageux", "weather.fog": "Brouillard", "weather.rain": "Pluie", "weather.storm": "Orage",
});

Object.assign(dict.it, { "like.thanks": "Grazie! È nei tuoi like" });
Object.assign(dict.en, { "like.thanks": "Thanks! Saved to your likes" });
Object.assign(dict.de, { "like.thanks": "Danke! In deinen Likes" });
Object.assign(dict.fr, { "like.thanks": "Merci ! Dans tes likes" });

Object.assign(dict.it, {
  "nav.offers": "Pacchetti su misura",
  "hero.nextEvent": "Prossimo evento", "hero.discoverEvent": "Scopri l'evento", "hero.after": "E in coda:",
  "survey.contact": "Lasciaci un contatto (email o telefono, facoltativo)",
  "survey.consent": "Acconsento a essere ricontattato con offerte in linea col mio profilo",
  "survey.suggestions": "Scelte per il tuo profilo",
  "survey.profileHint": "così ti suggeriamo le cose giuste",
  "detail.includes": "Cosa include",
});
Object.assign(dict.en, {
  "nav.offers": "Tailored packages",
  "hero.nextEvent": "Next event", "hero.discoverEvent": "See the event", "hero.after": "Up next:",
  "survey.contact": "Leave us a contact (email or phone, optional)",
  "survey.consent": "I agree to be contacted with offers matching my profile",
  "survey.suggestions": "Picked for your profile",
  "survey.profileHint": "so we can suggest the right things",
  "detail.includes": "What's included",
});
Object.assign(dict.de, {
  "nav.offers": "Pakete nach Maß",
  "hero.nextEvent": "Nächstes Event", "hero.discoverEvent": "Event ansehen", "hero.after": "Danach:",
  "survey.contact": "Hinterlasse uns einen Kontakt (E-Mail oder Telefon, optional)",
  "survey.consent": "Ich stimme zu, mit Angeboten passend zu meinem Profil kontaktiert zu werden",
  "survey.suggestions": "Ausgewählt für dein Profil",
  "survey.profileHint": "damit wir dir das Richtige vorschlagen",
  "detail.includes": "Was ist enthalten",
});
Object.assign(dict.fr, {
  "nav.offers": "Forfaits sur mesure",
  "hero.nextEvent": "Prochain événement", "hero.discoverEvent": "Voir l'événement", "hero.after": "Et ensuite :",
  "survey.contact": "Laisse-nous un contact (email ou téléphone, facultatif)",
  "survey.consent": "J'accepte d'être recontacté avec des offres adaptées à mon profil",
  "survey.suggestions": "Choisi pour ton profil",
  "survey.profileHint": "comme ça on te suggère les bonnes choses",
  "detail.includes": "Ce que ça inclut",
});

Object.assign(dict.it, { "hero.mastSub": "Maremma Toscana", "badge.sponsored": "In evidenza" });
Object.assign(dict.en, { "hero.mastSub": "Tuscan Maremma", "badge.sponsored": "Featured" });
Object.assign(dict.de, { "hero.mastSub": "Toskanische Maremma", "badge.sponsored": "Empfohlen" });
Object.assign(dict.fr, { "hero.mastSub": "Maremme toscane", "badge.sponsored": "À la une" });

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("fl-lang") || "it");
  useEffect(() => {
    localStorage.setItem("fl-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.it[k] || k;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

export function L(field, lang) {
  if (field == null) return "";
  if (typeof field === "string") return field;
  return field[lang] || field.it || field.en || "";
}
